import {getCookie, YM_UID} from '@web-landing/utils/cookie';

import packageJson from '../../../package.json';
import {emitTmrEvent} from '../helpers/logTmrEvent';
import {emitYmEvent} from '../helpers/ymEvent';

export type Subs = [string, string, string];

export const logs = {
  addMTPixel: (
    userIp: string | null | undefined,
    mtLinkId: string,
    subs: Subs,
  ) => {
    const ymUid = getCookie(YM_UID);

    const baseParams = {
      mt_link_id: mtLinkId,
      ip_address: userIp ?? '',
      ...subs.reduce(
        (acc, value, index) => {
          acc[`mt_sub${index + 1}`] = value ?? '';
          return acc;
        },
        {} as Record<string, string>,
      ),
      service_version: packageJson.version,
    };

    emitTmrEvent('mt_pixel', {
      ...baseParams,
      metrikaUid: ymUid ?? '',
      pageURL: document.location.href.split('?')[0],
    });

    emitYmEvent('mt_pixel', baseParams);
  },
};
